import { ErrorMessage } from '@app/core/models/alert/error-message';
import { WarningMessage } from '@app/core/models/alert/warning-message';
import * as R from 'ramda';
import { compose, cond, equals, prop } from 'ramda';

const NOT_DISMISSIBLE_MESSAGE_TYPES = ['LOGIN_ERROR'];

export enum ErrorLevel {
  Error = 'ERROR',
  Warning = 'WARNING'
}

const getType = prop('type');

const getLevel = compose(prop('level'), getType);
const getName = compose(prop('name'), getType);
const getTranslateMessageParameters = compose(prop('translateMessageParameters'), getType);

const isWarning = compose(equals(ErrorLevel.Warning), getLevel);
const isError = compose(equals(ErrorLevel.Error), getLevel);

const getMessage = compose(prop('message'), getType);
const getParameters = prop('messageParameters');
const isDismissible = (error) => R.not(R.includes(getName(error), NOT_DISMISSIBLE_MESSAGE_TYPES));
const createError = error => new ErrorMessage(getMessage(error), getParameters(error), isDismissible(error), getTranslateMessageParameters(error));
const createWarning = error => new WarningMessage(getMessage(error), getParameters(error));

export const createAlert = cond([
  [isError, createError],
  [isWarning, createWarning]
]);
